<!-- - VERIFICATION-->
<div
  class="event-log-box"
  [id]="'log-box-' + log.id"
  [class.is-select]="log.isSelected"
  [class.is-warning]="parseWarningLog()"
  (mouseenter)="onHoverLog($event, log.id)"
  (mouseleave)="onMouseLeaveLog($event, log)"
>
  <div class="event-log-action-box">
    <div class="action-box full-height" [ngClass]="computedBackground()">
      <div class="loader absolute log-loader" *ngIf="log.isLoading">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path log-stroke-color"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="4"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
      <ng-container *ngIf="!log.isLoading" [ngSwitch]="canIShowImageOrVideo()">
        <div *ngSwitchCase="'no permission'">No Permission</div>
        <div *ngSwitchCase="'need to upgrade plan'">Upgrade your dealer plan to access archived video.</div>
        <div *ngSwitchCase="'expired'">This video is expired</div>
        <div *ngSwitchCase="'privacy mode'">This camera is in privacy mode</div>
        <div *ngSwitchCase="'broken image'">Broken Image</div>
        <div *ngSwitchCase="'broken video'">Broken Video</div>
        <div *ngSwitchCase="'image'"><img [src]="log.imageUrl" (error)="isBrokenImage = true" /></div>
        <div *ngSwitchCase="'video'">
          <video [src]="log.safetyVideoUrl" controls="controls"></video>
        </div>
        <!-- - default : no image, no video  -->
        <div class="v-center" *ngSwitchDefault>
          <i class="material-icons" style="color: #4d96ff; font-size: 32px">verified_user</i>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="event-log-metadata">
    <div class="flex" style="gap: 6px; flex-direction: column">
      <div class="flex v-center" style="gap: 8px; flex-wrap: wrap">
        <div class="event-log-metadata-time">{{ log.eventCreated }}</div>
        <div class="event-log-metadata-category">
          <div class="badge verification">Verification</div>
          <ng-container *ngFor="let list of log.eventCodeList">
            <div
              class="--g-tooltip-content"
              (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
              style="margin: 0"
            >
              <div class="badge xml-code">{{ list.code }}</div>
              <div class="--g-tooltip tooltip-background">XML Code</div>
            </div>
          </ng-container>
        </div>
        <div
          class="--g-tooltip-content"
          *ngIf="parseWarningLog()"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
        >
          <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'rgb(205, 61, 100)'"></comp-icon>
          <div class="--g-tooltip" style="text-transform: none">
            This event includes data that could not be transmitted to the monitoring station.
          </div>
        </div>
      </div>
      <div class="event-log-metadata-device">
        <div
          class="--g-tooltip-content"
          *ngIf="log.zone_number"
          (mouseenter)="commonService.setTooltipPosition($event, 'top-center')"
          style="margin: 0"
        >
          <div class="event-log-metadata-device-zone">{{ log.zone_number }}</div>
          <div class="--g-tooltip tooltip-background">Device ID</div>
        </div>
        <div class="event-log-metadata-device-name" [class.no-name]="!log.name">{{ log.name ?? "No Name" }}</div>
      </div>
      <div class="event-log-metadata-other">
        {{ log.email }} - {{ log.status_text }}
        <!-- - 아직은 잘 모르겠어-->
      </div>
    </div>
    <div class="event-log-metadata-id">
      <span *ngIf="log?.event_id">ID {{ log.event_id }}</span>
      <span *ngIf="log?.partnerEventId"> | Partner ID {{ log.partnerEventId }}</span>
    </div>
    <!-- SLOT : toolbar-->
    <ng-container *ngTemplateOutlet="toolbar; context: { log: log }"></ng-container>
  </div>
</div>
